/** @jsx jsx */
import { Fragment } from 'react';
import Tooltip from '@atlaskit/tooltip';
import { jsx } from '@emotion/core';
import Button from '@atlaskit/button';
import AddIcon from '@atlaskit/icon/glyph/editor/add';
import { gridSize } from '@atlaskit/theme/constants';
import { useTheme } from '../../theme';
import { IconButton } from '../IconButton';
import { createButtonCSS, createIconCSS, getCreateButtonTheme } from './styles';
var grid = gridSize();
var TooltipSwitch = function (_a) {
    var buttonTooltip = _a.buttonTooltip, children = _a.children;
    return buttonTooltip ? (jsx(Tooltip, { content: buttonTooltip, hideTooltipOnClick: true }, children)) : (jsx(Fragment, null, children));
};
export var Create = function (_a) {
    var onClick = _a.onClick, text = _a.text, buttonTooltip = _a.buttonTooltip, iconButtonTooltip = _a.iconButtonTooltip, testId = _a.testId;
    var theme = useTheme();
    return (jsx("div", { css: {
            display: 'flex',
            alignItems: 'center',
            '&&': {
                marginLeft: grid * 1.5,
            },
            '& [data-hide-on-smallscreens]': createButtonCSS,
            '& [data-hide-on-largescreens]': createIconCSS,
        }, "data-testid": "create-button-wrapper" },
        jsx(TooltipSwitch, { buttonTooltip: buttonTooltip },
            jsx(Button, { id: "createGlobalItem", onClick: onClick, theme: getCreateButtonTheme(theme), testId: testId && testId + "-button", "data-hide-on-smallscreens": true }, text)),
        jsx(IconButton, { id: "createGlobalItemIconButton", testId: testId && testId + "-icon-button", icon: jsx(AddIcon, { label: text }), onClick: onClick, tooltip: iconButtonTooltip, theme: getCreateButtonTheme(theme), "aria-label": text, "data-hide-on-largescreens": true })));
};
export default Create;
//# sourceMappingURL=index.js.map